import styled from 'styled-components'

const ImageLogo = styled.img<{ size?: number }>`
  width: ${({ size }) => size || 28}px;
  height: ${({ size }) => size || 28}px;
  object-fit: contain;
  object-position: center;
  border-radius: 4px;
  flex-shrink: 0;
  display: block;
`

export function LogoRenderer({ logo, size = 28 }: { logo: React.ComponentType | string; alt?: string; size?: number }) {
  if (typeof logo === 'string') {
    return <ImageLogo src={logo} size={size} alt="Logo" fetchPriority="high" />
  }

  const LogoComponent = logo as React.ComponentType

  return (
    <div
      style={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: 'scale(1)',
        }}
        className="logo-svg-container"
      >
        <LogoComponent />
      </div>
    </div>
  )
}
